import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // reload the window after 10 seconds
    console.log("Awaiting payment notification. Will reloading after 10 seconds.");
    setTimeout(function(){ window.location.reload(); }, 10000);
  }
}
